import React, { Component } from 'react';
import './CookiePolicyNotification.scss';

export default class CookiePolicyNotification extends Component {
    
    constructor() {
        super();
        const isAcknowledged = localStorage.getItem('cookiePolicyAcknowledged');
        this.state = {
            isAcknowledged: isAcknowledged ? true : false
        }
    }

    hide = () => {
        this.setState({isAcknowledged: true});
        localStorage.setItem('cookiePolicyAcknowledged', true);
    }

    render() {
        return (
            this.state.isAcknowledged ? '' :
            <div className="cookie-policy-notification bg-dark text-white fixed-bottom">
                <p>We use cookies on this site to enhance your user experience. By clicking any link on this page your are giving your consent for us to set cookies. <a href="https://www.getpacer.com/terms/" target="blank">Privacy Policy</a></p>
                <button className="btn btn-primary" onClick={this.hide}>Accept</button>
            </div>
        )
    }
}